import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {RootState} from '@store';
import {getCalendar} from '@api/methods';

export interface CalendarState {
  snapshotIndex: {dateISO: string; id: number}[];
}

const initialState: CalendarState = {
  snapshotIndex: [],
};

export const fetchCalendarRange = createAsyncThunk<
  {snapshotIndex: {dateISO: string; id: number}[]},
  {before_date: string; after_date: string},
  {state: RootState}
>('calendar/fetchRange', async ({before_date, after_date}) => {
  const res = await getCalendar({before_date, after_date});
  const isoRegex = /^\d{4}-\d{2}-\d{2}$/;
  const snapshotIndex: {dateISO: string; id: number}[] = [];
  const walk = (val: unknown) => {
    if (val == null) return;
    if (Array.isArray(val)) {
      for (const item of val) walk(item);
      return;
    }
    if (typeof val === 'object') {
      const obj = val as Record<string, unknown>;
      for (const [k, v] of Object.entries(obj)) {
        if (
          k === 'date' ||
          k === 'created_at' ||
          k === 'createdAt' ||
          k === 'snapshot_date'
        ) {
          const dateISO = typeof v === 'string' && isoRegex.test(v) ? v : null;
          const idCandidate = (obj['snapshot_id'] ?? obj['id']) as unknown;
          if (
            dateISO &&
            (typeof idCandidate === 'number' ||
              (typeof idCandidate === 'string' && /^\d+$/.test(idCandidate)))
          ) {
            const id =
              typeof idCandidate === 'number' ? idCandidate : Number(idCandidate);
            snapshotIndex.push({dateISO, id});
          }
        } else {
          walk(v);
        }
      }
      return;
    }
  };
  walk(res);
  if (snapshotIndex.length > 0) {
    snapshotIndex.sort((a, b) =>
      a.dateISO < b.dateISO ? -1 : a.dateISO > b.dateISO ? 1 : 0,
    );
  }
  return {snapshotIndex};
});

const calendarSlice = createSlice({
  name: 'calendar',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchCalendarRange.fulfilled, (state, {payload}) => {
      state.snapshotIndex = payload.snapshotIndex;
    });
  },
});

export const selectCalendarSnapshotIndex = (state: RootState) =>
  state.calendar.snapshotIndex;

export default calendarSlice.reducer;
